// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Menu_overlay__Ae5wS","hidden":"Menu_hidden__RI1_t","container":"Menu_container__QmUvS"};